export const toHexCode = (val: string) => (!val || val?.match(/^#/gm) ? val : `#${val}`);
